import React from 'react';
import { ICatalogApplication, IWorkflowApplication } from '@app/models';

export type ApplicationInterfaceTypeUnion = ICatalogApplication & IWorkflowApplication;

const AppsContext = React.createContext({} as ApplicationInterfaceTypeUnion & { updateState: (name: string | undefined, value: unknown) => void });

export const AppsProvider = AppsContext.Provider;
export default AppsContext;
